// 点击弹出右下角客服面板
window.addEventListener('DOMContentLoaded', () => {
  $(document).on('click', '.onclick-live-chat', function () {
    zE('webWidget', 'open')
  })
})

/**
 * ! 点击导航栏定位到目标位置（注：不能再初始时刻获取，因为部分元素懒加载可能导致初始暂存的高度有误，导致跳转不准确）
 * @param {HTMLElement} target 所点击的定位元素
 */

function jumpToTarget(target) {
  const countrySelectContainer = document.querySelector('#countrySelectContainer') // 多家选择
  const stickyNav = document.querySelector('.xmmune') // 快速导航栏
  const countruContainerH = countrySelectContainer?.getBoundingClientRect()?.height || 0
  const stickyNavH = stickyNav?.getBoundingClientRect()?.height || 0
  const H = 65 + stickyNavH + countruContainerH // 国家选择栏高度可能出现可能不出现
  const _target = document.querySelector(target.dataset.pointId)
  console.log(`%c>> $target, _target, countruContainerH, stickyNavH, H`, 'color:yellow', target, _target, countruContainerH, stickyNavH, H)
  const targetPosition = _target.getBoundingClientRect().top + window.scrollY - H
  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth' // 平滑滚动
  })
}

/**
 * 获取url参数
 * @param {String} name url参数字段
 */
function getParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return !!name ? urlParams.get(name) : urlParams;
}